import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({name: 'safeHtml'})
export class SafeHtml implements PipeTransform {
  constructor(private sanitizer: DomSanitizer){}

  transform(html, handleSpace: boolean = true): any {
    if(handleSpace){
      html = html.replace(/(?:\r\n\r\n|\r\r|\n\n)/g, '</p><br><p>');
      html = '<p>' + html.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</p>';
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getSafeResourceUrl(html: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(html);
  }
}
